import { REPARTITION } from "../../AppVariables";


export default class SessionState {

  selectedRows = [];
  data = [];
  results= {
    total : 0,
    data:[],
    info : ""
  };
  resultsGroupBy= REPARTITION.TYPE_REPARTITIONS_LIMITS
  total = 0;
  confirmDeletion = false;
  allChecked = 0
  categories = {
    levelColors: [],
    names : []
  };
  columns = [];
  folder={id:"root", filters:[], folders:[]};


  static from(json) {
    let state = JSON.parse(JSON.stringify(json));
    //Object.assign(state, json);
    return state;
  }
}
